module.exports = __webpack_public_path__ + "static/campaign-1-e20638a84e691285d6072fbcfb1361c0.png";